// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_tXNXd","secondaryColumnCell":"secondary-column-cell_tXNXd","body":"body_T1G9F"};